import * as types from '../constants/actionTypes';

export const setRatingType = ratingType => ({
  type: types.SET_RATING_TYPE,
  ratingType,
});

export const enableSubmit = () => ({ type: types.ENABLE_SUBMIT });
export const disableSubmit = () => ({ type: types.DISABLE_SUBMIT });
